import { AdminAboutBio, ApiResponse } from "../../types/admin";
import httpClient from "../httpClient";

export const aboutApi = {
  getBio: (): Promise<ApiResponse<AdminAboutBio>> =>
    httpClient.get("/about/bio"),

  updateBio: (bio: AdminAboutBio): Promise<ApiResponse<AdminAboutBio>> =>
    httpClient.put("/about/bio", bio),
};
